import React, { useContext, useEffect, useReducer, useState } from "react";
import CustomInput from "../../../Components/CustomInput/CustomInput";
import {
  convertCommaToDot,
  convertDotToComma,
  formStep1,
  formStep1German,
} from "../../../Utility/utils";
import { formState } from "../InitialState/formState";
import { reducer } from "../consumptionReducer";
import {
  validateConstruction,
  validateEmail,
  validatePostalCode,
} from "../utility/validations";
import StepsHeader from "../../../Components/StepsHeader/StepsHeader";
import building from "../../../assets/dashboard/building.svg";
import styles from "./Step.module.css";
import CustomRadio from "../../../Components/CustomRadio/CustomRadio";
import { PatchApi, PostApi, getApi } from "../../../Utility/network";
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import NavButton from "./NavButton";
import { AppContext } from "../../../ContextApi/AppContext/AppContext";
import PopUpInfo from "../../../Components/PopUpInfo/PopUpInfo";
import { consumCertEngText } from "../../../Utility/engLangObject";
import { consumCertGerText } from "../../../Utility/gerLangObject";
import CustomCheckBox from "../../../Components/CustomCheckBox/CustomCheckBox";
import { useNavigate } from "react-router-dom";
import info from "../../../assets/componentAssets/info.svg";
let count = 10;

function Step1({ handleNavigation, currentPage, steps, ...props }) {
  const navigate = useNavigate();
  const { state, setState } = useContext(AppContext);
  const { language, stepLanguage } = state;
  const [state1, dispatch] = useReducer(reducer, formState);
  const [building_type, setBuilding_type] = useState([]);
  const [check, setCheck] = useState(false);
  const [occasion_type, setOccasion_type] = useState([]);
  const [initialLoad, setInitialLoad] = useState(false);
  const [errors, setErrors] = useState({});
  const [pop, setPop] = useState(false);
  const { step1 } = state1;
  const [emailCheck, setEmailCheck] = useState(false);
  const [infoText, setInfoText] = useState([]);
  const [disableNext, setDisableNext] = useState(true);
  useEffect(() => {
    setCheck(
      state?.otherData?.info.was_the_1977_thermal_insulation_regulation_met
    );
  }, [state?.otherData]);
  useEffect(() => {
    getTypeData();
    window.scroll(0, 0);
  }, []);
  const handlePopUp = (data) => {
    setPop(true);
    setInfoText(data);
  };
  const getTypeData = async () => {
    try {
      const dataResponse = await getApi(`/energy_consumption/building_type`);
      const occasionResponse = await getApi(`/energy_consumption/occasion`);
      setOccasion_type(occasionResponse.data.data);
      setBuilding_type(dataResponse.data.data);
      setDisableNext(false);
    } catch (error) {}
  };
  useEffect(() => {
    setState((prev) => ({
      ...prev,
      otherData: { ...prev.otherData, buildingData: { ...step1 } },
    }));
  }, [step1]);

  useEffect(() => {
    if (initialLoad) return;
    if (state?.otherData?.buildingData?.hasOwnProperty("occasion_id")) {
      count++;
      if (count > 50) return;
    }
    if (
      state?.otherData?.buildingData?.hasOwnProperty("occasion_id") &&
      state?.otherData?.buildingData?.occasion_id !== ""
    ) {
      const _data = JSON.stringify(state?.otherData?.buildingData);
      let _data1 = JSON.parse(_data);
      dispatch({
        type: "BULK_STEP1",
        payload: {
          ..._data1,
          floor_to_ceiling_height:
            language === "de"
              ? convertDotToComma(_data1.floor_to_ceiling_height)
              : convertCommaToDot(_data1.floor_to_ceiling_height),
        },
      });
      setInitialLoad(true);
    }
  }, [state, step1]);

  const validateRequiredField = (value, fieldName, type) => {
    if (type === "number") {
      if (!value) {
        return `${stepLanguage.number_of_apartments_error}`;
      }
      if (/[-eE+0]/.test(value)) {
        return `${stepLanguage.invalid_contain}`;
      }
      return "";
    } else if (type === "number0") {
      if (!value) {
        return `${stepLanguage.number_of_apartments_error}`;
      }
      if (!/^[1-9]\d*$/.test(value)) {
        return `${stepLanguage.invalid_contain}`;
      }
      return "";
    } else if (type === "numberGer") {
      if (!value) {
        return `${stepLanguage.number_of_apartments_error}`;
      }
      //
      const regex =
        language === "de"
          ? /^(?:[1-5](?:,\d{1,})?)$/
          : /^(?:[1-4](?:\.\d*)?|5(?:\.0*)?)$/;

      if (!regex.test(value)) {
        return `${stepLanguage.invalid_contain}`; // Invalid input message
      }
      return "";
    } else {
      return value ? "" : ` ${stepLanguage.occasion_error}`;
    }
  };

  const validateRequiredFields = (value, fieldName, type) => {
    if (type === "number") {
      if (!value) {
        return `${stepLanguage.occasion_error}`;
      }
      if (/[-eE+]/.test(value)) {
        return ` ${stepLanguage.invalid_contain}`;
      }
      return "";
    } else {
      return value ? "" : `${stepLanguage.occasion_error}`;
    }
  };

  const validateFields = (name, value) => {
    let error = "";
    const fieldName =
      formStep1.find((field) => field.name === name)?.title || name;
    switch (name) {
      case "email":
        error = validateEmail(value, stepLanguage);
        break;
      case "postal_code":
        error = validatePostalCode(value, stepLanguage);
        break;
      case "construction_year":
        error = validateConstruction(value, stepLanguage);
        break;
      case "number_of_apartments":
        error = validateRequiredField(value, fieldName, "number0");
        break;
      case "floors":
        error = validateRequiredField(value, fieldName, "number0");
        break;
      case "floor_to_ceiling_height":
        error = validateRequiredField(value, fieldName, "numberGer");
        break;
      case "building_type_id":
      case "occasion_id":
        error = validateRequiredField(value, fieldName);
        break;
      default:
        break;
    }
    return error;
  };
  const handleChange = (name, value, item) => {
    const error = validateFields(name, value);
    let values = value;
    if (numberType.includes(name)) {
      values = value.replace(/[^0-9]/g, "");
    }
    if (numberType.includes("floor_to_ceiling_height")) {
      values = value;
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));

    dispatch({
      type: "UPDATE_STEP1",
      payload: {
        [name]: values,
      },
    });
    // Perform validations
    // const errors = {};
    // switch (name) {
    //   case "email":
    //     const emailError = validateEmail(value);
    //     if (emailError) {
    //       errors.email = emailError;
    //     }
    //     break;
    //   case "postalCode":
    //     const postalCodeError = validatePostalCode(value);
    //     if (postalCodeError) {
    //       errors.postalCode = postalCodeError;
    //     }
    //     break;
    //   // Add more cases for other fields
    //   default:
    //     break;
    // }

    // // Dispatch all validation errors
    // if (Object.keys(errors).length > 0) {
    //   dispatch({
    //     type: "SET_ERROR1",
    //     payload: errors,
    //   });
    // }
  };

  const handleChange12 = (e) => {
    const { name, value } = e.target;
    let parsedValue = value;
    // Check if the value is a boolean string
    if (value === "true") {
      parsedValue = true;
    } else if (value === "false") {
      parsedValue = false;
    }
    // Check if the value is a number string
    else if (!isNaN(value) && value.trim() !== "") {
      parsedValue = parseFloat(value);
    }
    dispatch({
      type: "UPDATE_STEP1",
      payload: {
        [name]: value,
      },
    });
  };

  const handleSubmit = async (num, type) => {
    try {
      if (type === "next") {
        // Validate all fields before submitting
        // debugger
        const validationErrors = {};
        formStep1.forEach((field) => {
          const error = validateFields(field.name, step1[field.name]);
          if (error) validationErrors[field.name] = error;
        });
        setErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) {
          return; // Stop submission if there are validation errors
        }
        try {
          const {
            building_type_id,
            construction_year,
            email,
            floors,
            floor_to_ceiling_height,
            number_of_apartments,
            number_of_floors,
            occasion_id,
            postal_code,
            is_there_heated_basement,
          } = step1;

          let postData;
          step1.floor_to_ceiling_height = convertCommaToDot(
            step1.floor_to_ceiling_height
          );
          if (state.form_id) {
            postData = await PatchApi(
              `/energy_consumption/form/${state.form_id}/`,
              {
                building_type_id,
                construction_year,
                email,
                floors,
                floor_to_ceiling_height: convertCommaToDot(
                  floor_to_ceiling_height
                ),
                number_of_apartments,
                number_of_floors,
                occasion_id,
                postal_code,
                is_there_heated_basement,
                was_the_1977_thermal_insulation_regulation_met: check,
                language: language === "de" ? 2 : 1,
              }
            );
          } else {
            postData = await PostApi(`/energy_consumption/form/`, {
              building_type_id,
              construction_year,
              email,
              floors,
              floor_to_ceiling_height: convertCommaToDot(
                floor_to_ceiling_height
              ),
              number_of_apartments,
              number_of_floors,
              occasion_id,
              postal_code,
              is_there_heated_basement,
              language: language === "de" ? 2 : 1,
            });
          }
          setState((prev) => ({
            ...prev,
            otherData: {
              ...prev.otherData,
              construction_year: step1.construction_year,
            },
          }));
          if (postData.status === 200 || postData.status === 201) {
            setState((prev) => ({
              ...prev,
              page: prev.page + 1,
              filledPage:
                prev.filledPage >= prev.page + 1
                  ? prev.filledPage
                  : prev.page + 1,
              form_id: postData.data.data.id,
              formData: postData.data.data,
            }));
          } else {
            throw Error("api failed");
          }
        } catch (error) {
          alert(error);
        }
      } else if (type === "prev") {
        setState((prev) => ({ ...prev, page: prev.page - 1 }));
      }
    } catch (error) {
      alert("something went wrong");
    }
  };
  const handleCheckboxChange = () => {
    setCheck((prev) => !check);
  };
  const popData = {
    year1977: [
      {
        heading: stepLanguage.thermal_h,
        para1: stepLanguage.thermal_heading,

        para2: stepLanguage.thermal_point1,
        para3: stepLanguage.thermal_point2,
        para4: stepLanguage.thermal_point3,
        para5: stepLanguage.thermal_point4,
        para6: stepLanguage.thermal_point5,
      },
    ],
  };
  console.log(check, "was_the_1977_thermal_insulation_regulation_met");

  return (
    <div>
      <div className={styles.con}>
        <StepsHeader
          image={building}
          heading={stepLanguage.building_data}
          secPara={stepLanguage.provided_information}
        />

        <div className={styles.fieldDetails}>
          <div className={styles.fieldCom}>
            {(language === "de" ? formStep1German : formStep1).map((field) => (
              <div className={styles.fields}>
                {(field.fieldType === 1 || field.fieldType === 3) && (
                  <CustomInput
                    key={field.id}
                    label={field.title}
                    name={field.name}
                    value={step1[field.name] ?? ""}
                    onChange={handleChange}
                    postData={field?.popData}
                    options={
                      field.name === "building_type_id"
                        ? building_type
                        : field.name === "occasion_id"
                        ? occasion_type
                        : []
                    }
                    error={errors[field.name]}
                    helperText={errors[field.name]}
                    endIcon={field.id === 9 && "m"}
                    {...field}
                  />
                )}
                {/* <CustomRadio
                    data={field}
                    name={field.name}
 
                    onChanges={handleChange}
                  /> */}
                {field.fieldType === 2 && (
                  <div>
                    <p className={styles.fieldName}>
                      {stepLanguage.is_there_heated_basement}
                    </p>
                    <FormControl>
                      <RadioGroup
                        name="is_there_heated_basement" // Name of the radio group
                        value={step1.is_there_heated_basement} // Bind the state value
                        onChange={handleChange12} // Handle value changes
                      >
                        <div className={styles.Radio}>
                          <FormControlLabel
                            value={true}
                            control={<Radio />}
                            label={stepLanguage.yes}
                          />
                          <FormControlLabel
                            value={false}
                            control={<Radio />}
                            label={stepLanguage.no}
                          />
                        </div>
                      </RadioGroup>
                    </FormControl>
                  </div>
                )}
                {field.id === 4 && step1.construction_year <= 1976 && (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Checkbox
                      checked={check}
                      onChange={() => handleCheckboxChange()}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                    <span>{stepLanguage.thermal_checkbox} </span>
                    <img
                      src={info}
                      style={{ cursor: "pointer" }}
                      onClick={() => handlePopUp(popData?.year1977)}
                    />
                  </div>
                )}
                {/* <div>
                  {field?.id == 6 && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        // gap: "10px",
                      }}
                    >
                      <Checkbox
                        checked={emailCheck}
                        onChange={() => setEmailCheck((prev) => !emailCheck)}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      <div>
                        {stepLanguage?.email_start}
                        <a
                          style={{
                            margin: "0px",
                            fontSize: "15px",
                            lineHeight: "20px",
                            textDecoration: "underline",
                            color: "#22A156",
                            fontWeight: "600",
                            paddingLeft: "5px",
                          }}
                          href="https://greenox-group.de/datenschutz/"
                          target="_blank"
                        >
                          {stepLanguage.privacy_policy}
                        </a>
                      </div>
                    </div>
                  )}
                </div> */}
              </div>
            ))}
          </div>
        </div>
        {/* <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: "20px",
        }}
      >
        <Button
          variant="contained"
          disabled={currentPage <= 1}
          onClick={() => handleSubmit(-1, "prev")}
        >
          Previous
        </Button>
        <Button
          variant="contained"
          disabled={currentPage === steps.length}
          onClick={() => handleSubmit(1, "next")}
        >
          Next
        </Button>
      </div> */}
      </div>
      <NavButton
        handleSubmit={handleSubmit}
        disabled={
          disableNext ||
          (step1.construction_year >= 1850 &&
            step1.construction_year <= 1976 &&
            step1.number_of_apartments <= 4 &&
            !check)
        }
      />
      {pop && (
        <PopUpInfo
          handleClose={() => setPop(false)}
          open={pop}
          data={infoText}
        />
      )}
    </div>
  );
}

export default Step1;
const numberType = [
  "postal_code",
  "construction_year",
  "number_of_apartments",
  "floors",
];

const checkData = [
  {
    title:
      "The property complies with the Thermal Insulation Ordinance of 1977",
    id: 1,
  },
];
